import { IWorkflowFormState } from '@/store/workflow-form';
import { IWorkflowFormGetters } from './getters.types';
import {
  IWorkflowFormSubmission,
  WorkflowFormSubmission,
  IWorkflowFormSubmissionChecklist,
  WorkflowFormSubmissionChecklist,
  IDepartment,
  Department,
  IWorkflowFormSubmissionComment,
  WorkflowFormSubmissionComment,
  IUser,
  User,
  IDepartmentData,
  IWorkflowTransition,
  WorkflowTransition,
  WorkflowTransitionLog,
  IWorkflowTransitionLog
} from '@/models';

export const getters: IWorkflowFormGetters = {
  getWorkflowFormSubmissionCount(state: IWorkflowFormState): number {
    return state.count;
  },

  //submissions
  getWorkflowFormSubmissions(
    state: IWorkflowFormState
  ): IWorkflowFormSubmission[] {
    return state.workflowFormSubmissions.map(
      data => new WorkflowFormSubmission(data)
    );
  },

  getWorkflowFormSubmissionById: (state: IWorkflowFormState) => (
    id: number
  ): IWorkflowFormSubmission | undefined => {
    const data = (state.workflowFormSubmissions as IWorkflowFormSubmission[]).find(
      form => form.id === id
    );
    if (!data) {
      return undefined;
    }

    return new WorkflowFormSubmission(data as IWorkflowFormSubmission);
  },

  // activities
  getWorkflowFormSubmissionActivities: (
    state: IWorkflowFormState
  ): IWorkflowTransitionLog[] => {
    return state.activities.map(
      activity => new WorkflowTransitionLog(activity)
    );
  },

  getWorkflowFormSubmissionTransitions: (
    state: IWorkflowFormState
  ): IWorkflowTransition[] => {
    return state.workflowFormSubmissionTransitions.map(
      transition => new WorkflowTransition(transition)
    );
  },

  getWorkflowFormSubmissionsAvailableAssignees: (
    state: IWorkflowFormState
  ): IUser[] => {
    return state.workflowFormSubmissionAvailableAssignees.map(
      assignee => new User(assignee)
    );
  },

  getWorkflowFormSubmissionChecklists(
    state: IWorkflowFormState
  ): IWorkflowFormSubmissionChecklist[] {
    return state.workflowFormChecklists.map(
      data => new WorkflowFormSubmissionChecklist(data)
    );
  },

  getChecklistAssigneeOptions(state: IWorkflowFormState): IUser[] {
    return state.checklistAssigneeOptions.map(data => new User(data));
  },

  getWorkflowFormSubmissionChecklistsByDepartment: (
    state: IWorkflowFormState
  ) => (id: number): IWorkflowFormSubmissionChecklist[] => {
    const checklists = state.workflowFormChecklists.filter(
      checklist =>
        (checklist.todo_template.todo_department as IDepartmentData).id === id
    );

    return checklists.map(data => new WorkflowFormSubmissionChecklist(data));
  },

  getWorkflowFormSubmissionChecklistById: (state: IWorkflowFormState) => (
    id: number
  ): IWorkflowFormSubmissionChecklist | undefined => {
    const data = state.workflowFormChecklists.find(
      template => template.id === id
    );
    if (!data) {
      return undefined;
    }

    return new WorkflowFormSubmissionChecklist(data);
  },

  getWorkflowFormSubmissionDepartments(
    state: IWorkflowFormState
  ): IDepartment[] {
    return state.workflowFormDepartments.map(data => new Department(data));
  },

  getWorkflowFormSubmissionComments: (
    state: IWorkflowFormState
  ): IWorkflowFormSubmissionComment[] => {
    return state.comments.map(data => new WorkflowFormSubmissionComment(data));
  },

  getWorkflowFormSubmissionCommentById: (state: IWorkflowFormState) => (
    id: number
  ): IWorkflowFormSubmissionComment | undefined => {
    const data = state.comments.find(
      paymentrequisition => paymentrequisition.id === id
    );
    if (!data) {
      return undefined;
    }

    return new WorkflowFormSubmissionComment(data);
  },

  getWorkflowFormSubmissionMentionableUsers(
    state: IWorkflowFormState
  ): IUser[] {
    return state.mentionableUsers.map(data => new User(data));
  }
};
